import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMessageClock: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#2970FF',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 18.125C2.41917 18.125 2.33824 18.1092 2.26074 18.0775C2.02741 17.9808 1.875 17.7525 1.875 17.5V5C1.875 2.985 2.985 1.875 5 1.875H15C17.015 1.875 18.125 2.985 18.125 5V12.5C18.125 14.515 17.015 15.625 15 15.625H5.2592L2.9425 17.9417C2.8225 18.0617 2.6625 18.125 2.5 18.125ZM5 3.125C3.68583 3.125 3.125 3.68583 3.125 5V15.9908L4.55831 14.5575C4.67581 14.44 4.83417 14.3742 5 14.3742H15C16.3142 14.3742 16.875 13.8134 16.875 12.4992V4.99919C16.875 3.68502 16.3142 3.12419 15 3.12419H5V3.125ZM10 12.7083C7.8175 12.7083 6.04167 10.9325 6.04167 8.75C6.04167 6.5675 7.8175 4.79167 10 4.79167C12.1825 4.79167 13.9583 6.5675 13.9583 8.75C13.9583 10.9325 12.1825 12.7083 10 12.7083ZM10 6.04167C8.50667 6.04167 7.29167 7.25667 7.29167 8.75C7.29167 10.2433 8.50667 11.4583 10 11.4583C11.4933 11.4583 12.7083 10.2433 12.7083 8.75C12.7083 7.25667 11.4933 6.04167 10 6.04167ZM11.275 10.025C11.5192 9.78086 11.5192 9.38499 11.275 9.14083L10.625 8.4908V7.5C10.625 7.155 10.345 6.875 10 6.875C9.655 6.875 9.375 7.155 9.375 7.5V8.75C9.375 8.91583 9.44081 9.07502 9.55831 9.19169L10.3916 10.025C10.5133 10.1467 10.6733 10.2083 10.8333 10.2083C10.9933 10.2083 11.1534 10.1475 11.275 10.025Z"
      fill={color}
    />
  </svg>
);

export default IconMessageClock;
